
/* eslint-disable */
const globModules = [
  {
    name: 'masthead-project-listing-carousel',
    loader: () => import('./modules/masthead-project-listing-carousel'),
    
  },
{
    name: 'rep-list',
    loader: () => import('./modules/rep-list'),
    render: function(Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node => render(React.createElement(Component, node.dataset), node));
    }
  },
{
    name: 'document-list-with-buttons',
    loader: () => import('./modules/document-list-with-buttons'),
    
  },
{
    name: 'tabbed-featured-content',
    loader: () => import('./modules/tabbed-featured-content'),
    
  },
{
    name: 'alert-banner-enhanced',
    loader: () => import('./modules/alert-banner-enhanced'),
    
  },
{
    name: 'navigation-jumplinks',
    loader: () => import('./modules/navigation-jumplinks'),
    
  },
{
    name: 'flashing-system-calculator',
    loader: () => import('./modules/flashing-system-calculator'),
    render: function(Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node => render(React.createElement(Component, node.dataset), node));
    }
  },
{
    name: 'blog-listing',
    loader: () => import('./modules/blog-listing'),
    render: function(Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node => render(React.createElement(Component, node.dataset), node));
    }
  }
];

export default globModules;
